import Client from 'aws-appsync';
import { Auth } from 'aws-amplify';

const AppSyncClient = (config) =>
  new Client({
    disableOffline: true,
    url: config.get('api.endpoints.associateNotifications'),
    region: config.get('Auth.graphQL.region'),
    auth: {
      type: config.get('Auth.graphQL.type'),
      jwtToken: async () => (await Auth.currentSession()).getIdToken().getJwtToken(),
    },
  });

export default AppSyncClient;
